<div id="sessions-container" class="container">
    <div class="row" style="position:relative;">
        <div class="col-md-12 flex-between-center header">
            <h1
                jhitranslate="session-list.trainers.title"
                style="display: inline-block;"
            >
                <i
                    class="fa fa-bookmark-o fa-pre fa-pre"
                    aria-hidden="true"
                ></i>
                <span
                    *ngIf="!displayingMySessions && !displayingDeletedSessions"
                    >{{ 'session-list.title' | translate }}</span
                >
                <span *ngIf="displayingMySessions">{{
                    'session-list.title-mine' | translate
                }}</span>
                <span *ngIf="displayingDeletedSessions">{{
                    'session-list.title-deleted' | translate
                }}</span>
            </h1>
            <div class="flex">
                <button
                    title="Export"
                    *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE']"
                    (click)="export()"
                    class="btn btn-primary export-btn"
                >
                    <span
                        class="glyphicon glyphicon-export"
                        aria-hidden="true"
                    ></span>
                </button>
                <navigate-session-id></navigate-session-id>
            </div>
        </div>
    </div>

    <div class="row col-xs-12 nav-container" *ngIf="!displayingMySessions">
        <a class="btn btn-default" (click)="updateDate(-1, 'years')">
            <i class="fa fa-angle-double-left"></i>
        </a>
        <a class="btn btn-default" (click)="updateDate(-1, 'months')">
            <i class="fa fa-angle-left"></i>
        </a>
        <div class="current-month">{{ displayMonth }}</div>
        <a class="btn btn-default" (click)="updateDate(1, 'months')">
            <i class="fa fa-angle-right"></i>
        </a>
        <a class="btn btn-default" (click)="updateDate(1, 'years')">
            <i class="fa fa-angle-double-right"></i>
        </a>
    </div>

    <div class="col-xs-12 table-responsive">
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th style="width: 100%" (click)="stringSortBy('title')">{{ 'session-list.list.title' | translate}}</th>
                <th style="min-width: 130px" (click)="dateSortBy()">{{ 'session-list.list.startDate' | translate}}</th>
                <th style="min-width: 100px" (click)="numberSortBy('duration')">{{ 'session-list.list.duration' | translate}}</th>
                <th style="min-width: 70px" (click)="stringSortBy('type')">{{ 'session-list.list.type' | translate}}</th>
                <th style="min-width: 230px" (click)="stringSortBy('location')">{{ 'session-list.list.location' | translate}}</th>
                <th *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE', 'ROLE_SESSION_PLANNER']" style="min-width: 200px "
                    (click)="stringSortBy('trainer')">{{ 'session-list.list.trainer' | translate}}
                </th>
                <th style="min-width: 130px" (click)="numberSortBy('session-list.list.nbConfirmedStudents')">
                    {{'session-list.list.students' | translate}}
                </th>
                <th style="min-width: 130px" (click)="numberSortBy('session-list.list.nbConfirmedStudents')">
                    {{'session-list.list.alerts' | translate}}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let session of sessions" class="session-line" [ngClass]="{'past-session': session.startDate < date}">
                <td style="user-select: none">
                    <a uiSref="session-detail" [uiParams]="{ id: session.id }">
                        {{session.title}}
                        <span *ngIf="session.linkedTraining">({{session.linkedTraining.title}})</span>
                        <span *ngIf="!session.linkedTraining && session.subject">({{session.subject}})</span>
                    </a>
                </td>
                <td>
                    <a uiSref="session-detail" [uiParams]="{ id: session.id }">
                        {{session.startDate | formatdatepipe}}
                    </a>
                </td>
                <td class="text-center">
                    <a uiSref="session-detail" [uiParams]="{ id: session.id }">
                        {{session.days}}
                    </a>
                </td>
                <td>
                    <a uiSref="session-detail" [uiParams]="{ id: session.id }">
                        {{session.type}}
                    </a>
                </td>
                <td>
                    <a uiSref="session-detail" [uiParams]="{ id: session.id }">
                        {{session.location}}
                    </a>
                </td>
                <td *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE', 'ROLE_SESSION_PLANNER']">
                    <a *ngIf="session.trainer !== 'À définir'"
                       uiSref="session-detail" [uiParams]="{ id: session.id }">
                        {{session.trainer}}
                        <span
                            *ngIf="session.additionalTrainers != null && session.additionalTrainers.length > 0"
                            title="{{additionalTrainersList(session)}}"
                        >
                            +{{session.additionalTrainers.length}}
                        </span>
                    </a>
                    <a *ngIf="session.trainer === 'À définir'"
                       uiSref="session-detail" [uiParams]="{ id: session.id }">
                        <b>{{session.trainer}}</b>
                    </a>
                </td>
                <td>
                    <a uiSref="session-detail" [uiParams]="{ id: session.id }">
                        {{getFormattedStudentCount(session)}}
                    </a>
                </td>


                <td >
                    <a *jhiHasAnyAuthority="['ROLE_BILLING_ADMIN']">
                        {{"session-details.timesheet" | translate}}

                        <i *ngIf="session.timesheetSaved; else timesheetUnsaved" class="fa fa-check" style="color: #308852; font-size: 1.5em;"></i>
                        <ng-template #timesheetUnsaved>
                            <i class="fa fa-times" style="color: #ff0b27; font-size: 1.5em;"></i>
                        </ng-template>
                    </a>
                </td>
                


            </tr>
            </tbody>
        </table>
        <loading *ngIf="loadingSessions"></loading>
    </div>
    <button
        *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SALE']"
        class="btn btn-primary btn-round btn-lg"
        uiSref="session-create"
    >
        +
    </button>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/list/list.component.html